import { render, staticRenderFns } from "./diferencaItensRomaneioESaidas.vue?vue&type=template&id=4c458aae&"
import script from "./diferencaItensRomaneioESaidas.vue?vue&type=script&lang=js&"
export * from "./diferencaItensRomaneioESaidas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VForm } from 'vuetify/lib/components/VForm';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VBtn,VForm,VSnackbar})
